import React from 'react';
import { useHistory } from 'react-router-dom';

import Header from 'components/AppBar';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AccountResponse } from 'models/user';

import { HeaderContainer, HeaderTitle, Container, MenuItem, ItemTitle, IconEdit } from './styles';

interface TravelerUserProfile extends AccountResponse {
  nationality?: string;
}

interface Props {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  image?: string;
  user: TravelerUserProfile | null;
}

const AdminToolContainer = ({ isLoading, setLoading, user, image }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();

  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <>
          <Mobile>
            <Header goBack={() => history.push('/corporate/dashboard')}>
              <HeaderContainer>
                <HeaderTitle>Admin Tool</HeaderTitle>
              </HeaderContainer>
            </Header>
          </Mobile>

          <Desktop>
            <ScreenHeader title="Admin Tool" />
          </Desktop>

          <Container>
            <MenuItem onClick={() => history.push('/corporate/adminTool/updateUserIsActive')}>
              <ItemTitle>{t('adminTool.menu.updateUser')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>

            <MenuItem onClick={() => history.push('/corporate/adminTool/addExtraCharge')}>
              <ItemTitle>{t('adminTool.menu.importExtraCharge')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>

            <MenuItem onClick={() => history.push('/corporate/adminTool/addImplementator')}>
              <ItemTitle>{t('adminTool.menu.addImplementator')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>
            
            <MenuItem onClick={() => history.push('/corporate/adminTool/updateItinerary')}>
              <ItemTitle>{t('adminTool.menu.updateItinerary')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>

            
            <MenuItem onClick={() => history.push('/corporate/adminTool/sendTravelToApprove')}>
              <ItemTitle>{t('adminTool.menu.sendTravelToApprove')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>

            <MenuItem onClick={() => history.push('/corporate/adminTool/retryItineraryApproval')}>
              <ItemTitle>{t('adminTool.menu.retryItineraryApproval')}</ItemTitle>
              <IconEdit src="/corporate/images/edit-arrow-right.svg" />
            </MenuItem>
          </Container>
        </>
      )}
    </>
  );
};

export default AdminToolContainer;
